import template from './otherAdvisers.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    otherAdvisers: '<',
    contacts: '<',
    contactEmployers: '<',
    workflow: '<',
    assets: '<',
    homeLoanSecurities: '<',
    insurances: '<',
    countries: '<',
    isDealOwnerBroker: '<',
    isTicketSettled: '<',
    onFinished: '&'
  },
controller: class controller {
    constructor($rootScope, $mdMedia, helperService, otherAdvisersService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.organizationCountry = '';
      ctrl.availableOtherAdviserTypes = [];
      ctrl.isReady = false;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry().name;
        ctrl.otherAdvisers = ctrl.otherAdvisers || [];
        ctrl.contacts = ctrl.contacts || [];
        ctrl.contactEmployers = ctrl.contactEmployers || [];
        ctrl.workflow = ctrl.workflow || {};
        ctrl.assets = ctrl.assets || [];
        ctrl.homeLoanSecurities = ctrl.homeLoanSecurities || [];
        ctrl.insurances = ctrl.insurances || [];
        ctrl.countries = ctrl.countries || [];
        ctrl.isDealOwnerBroker = ctrl.isDealOwnerBroker || false;
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.availableOtherAdviserTypes = otherAdvisersService.getAvailableOtherAdviserTypes({
          workflow: ctrl.workflow
        });
        ctrl.isReady = true;
      };

      ctrl.otherAdviserAdd = (otherAdviserType) => {
        otherAdvisersService.otherAdviserAdd(ctrl.otherAdvisers, otherAdviserType);
      };

      ctrl.otherAdviserDelete = (otherAdviser) => {
        const idx = helperService.findIndexById(ctrl.otherAdvisers, otherAdviser.id);
        if (idx > -1) {
          ctrl.otherAdvisers = otherAdvisersService.otherAdviserDelete(ctrl.otherAdvisers, idx);
          ctrl.saveOtherAdvisers();
        }
      };

      ctrl.getLastIndex = (data, idType) => helperService.getLastIndex(data, idType);

      /*
       * Save other advisers
       * --------------------------------------------------------------------------------
       */
      ctrl.saveOtherAdvisers = (otherAdviser) => {
        if (otherAdviser) {
          const idx = helperService.findIndexById(ctrl.otherAdvisers, otherAdviser.id);
          if (idx > -1) {
            ctrl.otherAdvisers.splice(idx, 1);
            ctrl.otherAdvisers.splice(idx, 0, otherAdviser);
          } else {
            ctrl.otherAdvisers.push(otherAdviser);
          }
        }
        ctrl.onFinished({ otherAdvisers: ctrl.otherAdvisers });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
